import { useQuery } from '@tanstack/react-query';
import { keys } from '@/lib/query/keys';
import { pageEditorApi } from './api';

/** The site map + page outlines. The registry is static per backend build; rows change. */
export function useOutlines(enabled = true) {
  return useQuery({
    queryKey: keys.pages.outlines(),
    queryFn: () => pageEditorApi.outlines(),
    staleTime: 60_000,
    enabled,
  });
}
